<!--
列表显示的中枢控制模块,通过判断
1. 调度不同的显示cell单元模块
2. 支持下拉刷新，和上拉翻页
3. 服务端listUrl必须是get方式传参
4. 不负责显示详情，详情处理由onSelect(item) 传出
-->
<template>
  <div>
    <Wp_pull_list
        :url="listUrl"
        :all-params="allParams"
        :page-size="allParams.size"
        @onLoad="onLoad"
    >
      <van-grid
          :border="false"
          :center="true"
          :gutter="4"
          :clickable="true"
          :column-num="columnNum"
          style="width: 100%;background-color: #EEEEEE">
        <blockquote v-for="(item,index) in listItem" :key="index" :style="{width:cellWidth}">
          <van-grid-item @click="onSelect(item)">
            <UnionActivityCell :item="item"></UnionActivityCell>
          </van-grid-item>
        </blockquote>
      </van-grid>
    </Wp_pull_list>

    <van-popup
        v-model="showActivityInfo"
        closeable
        round
        position="bottom"
        :style="{ height: '90%' }"
    >
      <JdActivityInfoCard :act-data="currentActivityInfo"></JdActivityInfoCard>
    </van-popup>
  </div>
</template>
<script>
import Wp_pull_list from './Wp_pull_list'
import UnionActivityCell from '../cell/UnionActivityCell'
import JdActivityInfoCard from '../card/JdActivityInfoCard'

export default {
  components: { JdActivityInfoCard, UnionActivityCell, Wp_pull_list },
  props: {
    listUrl: {}
  },
  data () {
    return {
      columnNum: 2,
      cellWidth: '50%',
      showActivityInfo: false,
      allParams: {
        page: 1,
        size: 20,
      },
      listItem: [],
      total: 0,
      currentActivityInfo: {},
    }
  },
  watch: {
    listUrl: {
      handler (newV, oldV) {
        if (newV) {
          this.allParams.page = 1
          this.listItem = []
        }
      },
      immediate: true,
      deep: true,
    }
  },
  mounted () {

  },
  methods: {
    onLoad (list) {
      console.log('==UnionList onLoad==')
      console.log(list)
      if (list && list.length > 0) {
        this.listItem = list
      }
    },
    onSelect (item) {
      if (item) {
        this.currentActivityInfo = item
        this.showActivityInfo = true
      }
    }
  }
}
</script>